import React, { useContext, useEffect, useState } from 'react';
import { LangContext } from '../../context/DataContext';
import { Link } from 'react-router-dom'
import DocumentTitle from '../../components/common/document-title/DocumentTitle';
import './home-styles.css';
import Header from "../../components/layout/header/Header"
import Footer from "../../components/layout/footer/Footer"
import UseLangLocation from '../../hooks/UseLangLocation';
 
/* const pageContent = {
    es: {
        title: 'Informes técnicos',
        description: 'En este sitio se encuentran los resultados de investigaciones técnicas llevadas a cabo por LACNIC. Estos estudios han sido coordinados con la colaboración de distintos investigadores de la región.',
        latestTitle: 'Últimos informes:'
    },
    en: {
        title: 'Technical Reports',
        description: 'This site contains the results of research carried out by LACNIC within the framework of the projects "Security, Stability and Resilience Studies (SSR)" and "Strengthening of Regional Internet Infrastructure".',
        latestTitle: 'Latest Reports:'
    },
    pt: {
        title: 'Relatórios técnicos',
        description: 'Este site contém os resultados das pesquisas realizadas pelo LACNIC no âmbito dos projetos "Estudos de Segurança, Estabilidade e Resiliência (SSR)" e "Fortalecimento da Infraestrutura Regional da Internet".',
        latestTitle: 'Últimos relatórios:'
    }
}; */

export default function HomeMainContent({routes, lang}) {
	const { myLang } = useContext(LangContext)
	const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 760);
	/* const content = pageContent[myLang]; */
	
	useEffect(() => {
		const handleResize = () => {
		setIsSmallScreen(window.innerWidth <= 760);
		};

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);
	return (
		<UseLangLocation>
			<Header url_es="/es" url_en="/en" url_pt="/pt" routes={routes} lang={lang} />
			{myLang === 'es' && <Es isSmallScreen={isSmallScreen} />}
			{myLang === 'en' && <En isSmallScreen={isSmallScreen}/>}
			{myLang === 'pt' && <Pt isSmallScreen={isSmallScreen} />}
			{/* <main className="main_index" >
				<div>
                    <h1>
                        <DocumentTitle>{content.title}</DocumentTitle>
                    </h1>
                    <p>{content.description}</p>
				</div>
			</main> */}
			<Footer className="master_foot foot_home" />
		</UseLangLocation>
	);
}

function Es({isSmallScreen}) { 
	return (
		<>
			<main className="main_index"  >
				<div>
					<h1><DocumentTitle>Informes técnicos</DocumentTitle> </h1>
					<p>En este sitio se encuentran los resultados de investigaciones técnicas llevadas a cabo
						por LACNIC. Estos estudios han sido coordinados con la colaboración de distintos investigadores de
						la región. 
					</p>
					<div className="grid_it_reports">
						<div>
							<div><Link className="grid_it_cib" to="/es/ciberseguridad"><img alt="ver" src="/images/ciberseguridad.png" width="512" height="512" /><span className='text'>{isSmallScreen ? 'Ciberseguridad' : 'Mejorando la ciberseguridad'}</span></Link></div>
							<div><Link className="grid_it_int" to="/es/interconexion"><img alt="ver" src="/images/interconexion.png" width="512" height="512" /><span className='text'> {isSmallScreen ? 'Interconexión' : 'Fortaleciendo la interconexión regional'}</span></Link></div>
							<div><Link className="grid_it_cib_ip" to="/es/ipv6"><img alt="ver" src="/images/ipv6.png" width="512" height="512" /><span className='text'>{isSmallScreen ? 'IPv6' : 'Promoviendo el despliegue IPv6'}</span></Link></div>
						</div>
					</div>
				</div> 
			</main>
			<article className="index">
				<section> 
					<h2>Últimos informes: </h2>
					<div className="grid_imasd_latest">
						<div>
							<img alt="ver" src="/images/latest-reports/ciberseguridad-proteccion-digital.png" />
							<h3>Análisis de funcionamiento del Trust Anchor (TA) de RPKI v1</h3>
							<a href="/es/interconexion/analisis-de-funcionamiento-del-trust-anchor-ta-de-rpki-v1"><i className="far fa-file-alt"></i> Leer informe</a>
						</div> 
						<div>
							<img alt="ver" src="/images/cibersecurity-smart-city.png" />
							<h3>Evolución global y regional de la adopción de RPKI</h3>
							<a href="/es/interconexion/evolucion-global-y-regional-de-la-adopcion-de-rpki"><i className="far fa-file-alt"></i>  Leer informe</a>
						</div> 
					    <div>
							<img alt="ver" src="/images/latest-reports/interconexion-trafico-conectividad-ixp.png" />
							<h3>Análisis de incidentes de enrutamiento en la región</h3>
							<a href="/reportes/interconexion/lacnic-analisis-incidentes-enrutamiento-lac-es.pdf"><i className="far fa-file-alt"></i>  Leer informe</a>
						</div>  
						 
					</div>
				</section>
			</article>
		</>
	)
}
function En({isSmallScreen}) {
	
	return (
		<>
			<main className="main_index">
				<div>
					<h1><DocumentTitle>Technical Reports</DocumentTitle> </h1>
					<p>This site contains the results of research carried out by LACNIC within the framework of the projects "Security, Stability and Resilience Studies (SSR)" and "Strengthening of Regional Internet Infrastructure". These studies have been coordinated by LACNIC with the collaboration of different researchers in the region.</p>
					<div className="grid_it_reports">
						<div>
							<div><Link className="grid_it_cib" to="/en/cybersecurity"><img alt="ver" src="/images/ciberseguridad.png" width="512" height="512" />{isSmallScreen ? 'Cybersecurity' : 'Improving cybersecurity'}</Link></div>
							<div><Link className="grid_it_int" to="/en/interconnection"><img alt="ver" src="/images/interconexion.png" width="512" height="512" />{isSmallScreen ? 'Interconnection' : 'Strengthening regional interconnection'}</Link></div>
							<div><Link className="grid_it_cib_ip" to="/en/ipv6"><img alt="ver" src="/images/ipv6.png" width="512" height="512" />{isSmallScreen ? 'IPv6' : 'Promoting IPv6 deployment'}</Link></div>
						</div>
					</div>
				</div> 
			</main>
			<article className="index">
				<section>
					<h2>Latest Reports:</h2>
					<div className="grid_imasd_latest">
						<div>
							<img alt="ver" src="/images/cibersecurity-smart-city.png" />
							<h3>Global and Regional Evolution of RPKI Adoption</h3>
							<a href="/en/interconnection/global-and-regional-evolution-of-rpki-adoption" id="bot_info2"><i className="far fa-file-alt"></i>  Read Report</a>
						</div>  
						<div>
							<img alt="ver" src="/images/latest-reports/ciberseguridad-proteccion-digital.png" />
							<h3>A Study of DDoS Attacks</h3>
							<a href="/en/cybersecurity/a-study-of-ddos-attacks"><i className="far fa-file-alt"></i> Read Report</a>
						</div>
						<div>
							<img alt="ver" src="/images/cibersecurity-smart-city.png" />
							<h3>Best Practices for IXPs</h3>
							<a href="/en/interconnection/best-practices-for-ixps"><i className="far fa-file-alt"></i>  Read Report</a>
						</div> 
						 
					</div>
				</section>
			</article>
		</>
	)
}
function Pt({isSmallScreen}) {
	return (
		<>
			<main className="main_index">
				<div>
					<h1><DocumentTitle>Relatórios técnicos</DocumentTitle> </h1>
					<p>Este site contém os resultados das pesquisas realizadas pelo LACNIC no âmbito dos projetos "Estudos de Segurança, Estabilidade e Resiliência (SSR)" e "Fortalecimento da Infraestrutura Regional da Internet". Esses estudos foram coordenados pelo LACNIC com a colaboração de diversos pesquisadores da região.</p>
					<div className="grid_it_reports">
						<div>
							<div><Link className="grid_it_cib" to="/pt/ciberseguranca"><img alt="ver" src="/images/ciberseguridad.png" width="512" height="512" />{isSmallScreen ? 'Segurança cibernética' : 'Melhorando a segurança cibernética'}</Link></div>
							<div><Link className="grid_it_int" to="/pt/interconexao"><img alt="ver" src="/images/interconexion.png" width="512" height="512" />{isSmallScreen ? 'Interconexão' : 'Fortalecimento da interconexão regional'}</Link></div>
							<div><Link className="grid_it_cib_ip" to="/pt/ipv6"><img alt="ver" src="/images/ipv6.png" width="512" height="512" />{isSmallScreen ? 'IPv6' : 'Promovendo a implantação do IPv6'}</Link></div>
						</div>
					</div>
				</div>
			</main>
			<article className="index">
				<section>
					<h2>Últimos relatórios:</h2>
					<div className="grid_imasd_latest">
						 
						<div>
							<img alt="ver" src="/images/latest-reports/ciberseguridad-proteccion-digital.png" />
							<h3>Pesquisa sobre ataques de DDoS</h3>
							<a href="/pt/ciberseguranca/pesquisa-sobre-ataques-de-ddos"><i className="far fa-file-alt"></i>  Leia o Relatório</a>
						</div>
						<div>
							<img alt="ver" src="/images/cibersecurity-smart-city.png" />
							<h3>Melhores práticas para IXP</h3>
							<a href="/pt/interconexao/melhores-praticas-para-ixp"><i className="far fa-file-alt"></i>  Leia o Relatório</a>
						</div> 
						<div>
							<img alt="ver" src="/images/pantalla-proyector-hologramas-tecnologia-sistema-nube.jpeg" />
							<h3>Análise das rotas do tráfego dentro de cada país da região LAC</h3>
							<a href="/pt/interconexao/analise-das-rotas-do-trafego-dentro-de-cada-pais-da-regiao-lac" ><i className="far fa-file-alt"></i>  Leia o Relatório</a>
						</div>  
					</div>
				</section>
			</article>
		</>
	)
}